import * as qs from 'qs'
import { slug } from 'utils'

const getJoinWorkspaceLink = ({
  workspaceName,
  workspaceId,
  inviteId,
  redirect
}) => {
  const query = qs.stringify({ inviteId, redirect })
  // prettier-ignore
  return `/workspace/${workspaceId}/${slug(workspaceName)}/admin/join${query ? `?${query}`: ""}`
}

export { getJoinWorkspaceLink }
